import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "panel"]
  static values = { defaultTab: String }

  connect() {
    this.show(this.defaultTabValue || this.panelTargets[0]?.dataset.tab)
  }

  select(event) {
    this.show(event.currentTarget.dataset.tab)
  }

  show(tabName) {
    this.panelTargets.forEach((panel) => {
      panel.classList.toggle("hidden", panel.dataset.tab !== tabName)
    })

    this.buttonTargets.forEach((button) => {
      const isActive = button.dataset.tab === tabName
      button.classList.toggle("border-blue-500", isActive)
      button.classList.toggle("text-blue-600", isActive)
      button.classList.toggle("border-transparent", !isActive)
      button.classList.toggle("text-gray-500", !isActive)
    })
  }
}
